import { Order } from 'src/models/Order'
import { OrderingHttpClientInterface } from 'src/network/HttpClientInterface'
import { CustomerResponse } from 'src/network/types'

export class MockOrderingClient implements OrderingHttpClientInterface {
    async getCustomer(): Promise<CustomerResponse> {
        await document.mocks.isReady()

        return document.mocks.getCustomerData()
    }

    async getOrder(): Promise<Order> {
        await document.mocks.isReady()

        return document.mocks.getOrderData()
    }

    async updateOrder(): Promise<Order> {
        await document.mocks.isReady()

        return document.mocks.getOrderData()
    }
}
